import React from 'react';
import {FaGithub} from "react-icons/fa";
import {GrMail} from "react-icons/gr";
// import {SiLeetcode} from "react-icons/si"
import { FaTelegram } from "react-icons/fa6";
import { FaTwitter } from 'react-icons/fa';
const Footer = () => {
  return (
    <footer>
      <h4>Developed by Rudy. Tan</h4>
      <h4>Copyright &copy; 2021 R.T</h4>
      <div className='footerLinks'>
        <a href="https://github.com/486xtm" target='_blank'><FaGithub/></a>
        <a href="https://x.com/StephanieH87620" target='_blank'><FaTwitter/></a>
        <a href='mailTo:codemaster941111@gmail.com' target='_blank'><GrMail/></a>
        <a href="https://t.me/sealife_RC" target="_blank"><FaTelegram/></a>
      </div>
    </footer>
  )
}

export default Footer